// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as IssuesApiModelV2 from "../api-model/IssuesApiModelV2.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function toIssue(issue) {
  return {
          issue_name: issue.issue_name,
          issue_comment_required: issue.issue_comment_required
        };
}

function groupByCategory(data) {
  var categorized = Belt_List.keep(Belt_List.map(data.category_enum, (function (cat) {
              return {
                      category_id: cat.id,
                      category_name: cat.name,
                      issues: Belt_List.map(Belt_List.keep(data.issues, (function (issue) {
                                  return issue.category_enum_id === cat.id;
                                })), toIssue)
                    };
            })), (function (cat) {
          return Belt_List.length(cat.issues) > 0;
        }));
  return {
          categories: categorized
        };
}

function execute(json) {
  return groupByCategory(DeccoUtils$Catalyst.resolveResult(IssuesApiModelV2.t_decode(json), "IssuesEntityMapperV2.res"));
}

export {
  toIssue ,
  groupByCategory ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
